<div id="container" class="cls-container checkout" [ngClass]="bloqueio ? 'checkout-bloqueado' : ''">
  <div class="cls-content">
    <div class="cls-content-lg panel">
      <div class="panel-heading">
        <h3 class="panel-title"><a class="link-panel-title">{{clientData ? titles[2] : tokenId ? titles[0] : titles[1]}}</a></h3>
        <div class="pagamento-seguro">
          <p>
            <small>
              Ambiente Seguro
              <strong>pague.lá</strong>
            </small>
          </p>
          <div class="cadeado">
            <svg id="918eb8b3-fc12-4a16-b7c9-5be32242ad65" data-name="Camada 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 35 35">
              <defs>
                <linearGradient id="6ecd3835-66b2-430e-b7e7-4ed4ea3828fd" x1="5.1" y1="8.3" x2="29.88" y2="33.08" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stop-color="#ffff70" />
                  <stop offset="0.18" stop-color="#f9f668" />
                  <stop offset="0.47" stop-color="#eadf52" />
                  <stop offset="0.84" stop-color="#d1b92f" />
                  <stop offset="1" stop-color="#c4a51d" />
                </linearGradient>
              </defs>
              <title>Prancheta 8</title>
              <path d="M27,12V9.15A9.29,9.29,0,0,0,17.59,0h-.31A9.22,9.22,0,0,0,8,9.15V12a3.48,3.48,0,0,0-3,3.44v16A3.49,3.49,0,0,0,8.49,35h18A3.49,3.49,0,0,0,30,31.51v-16A3.48,3.48,0,0,0,27,12ZM17.28,3h.31A6.37,6.37,0,0,1,24,9.15V12H11V9.15A6.22,6.22,0,0,1,17.28,3ZM27,31.51a.49.49,0,0,1-.49.49h-18A.49.49,0,0,1,8,31.51v-16A.49.49,0,0,1,8.49,15h18a.49.49,0,0,1,.49.49Z" style="fill:url(#6ecd3835-66b2-430e-b7e7-4ed4ea3828fd)" />
            </svg>
          </div>
        </div>
      </div>
      <div class="panel-content" id="conteudo-checkout">
        <!-- Info -->
        <div class="panel-body1 text-left">
          <img *ngIf="profilePicture" class="logo-cliente" [src]="profilePicture" />
          <div class="infos">
            <h5 id="nome-cliente" *ngIf="account && (account.Fantasia || account.Nome)">{{ account && account.Fantasia ? account.Fantasia : account.Nome }}</h5>
          </div>
          <div *ngIf="sales && sales.length > 0" class="info-venda" id="info-venda">
            <div *ngFor="let sale of sales" class="venda">
              <hr>
              <h5 *ngIf="sale && sale.Cliente && sale.Cliente.Nome">{{ sale.Cliente.Nome  }}</h5>
              <p class="desc-venda">{{sale.Descricao}}</p>
              <div *ngIf="sale.ContasReceber && sale.ContasReceber.length > 0 && sale.Recorrencia">
                <div class="valores-recorrencia flex space-between" *ngFor="let item of sale.ContasReceber; let i = index">
                  <div class="text-container-recorrencia">
                    <h2>{{i+1}}ª</h2>
                    <span class="valor-data-recorrencia"> em {{ getFormatedDate(item.DataVencimento) }}</span>
                    <span class="texto-destaque-recorrencia valor-recorrencia" *ngIf="isValor()">{{item.ValorAberto.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</span>
                  </div>
                </div>
              </div>
              <div class="valor-container" *ngIf="!sale.Recorrencia">
                <span class="texto-destaque" *ngIf="(sale.Recorrencia && sale.Recorrencia.QuantidadeRecorrencia && sale.Recorrencia.QuantidadeRecorrencia > 1)">{{ sale.Recorrencia.QuantidadeRecorrencia }} <span>X</span></span>
                <span class="qtd-vezes" *ngIf="sale.Recorrencia && sale.Recorrencia.QuantidadeRecorrencia && sale.Recorrencia.QuantidadeRecorrencia > 1">Recorrente</span>
                <span class="texto-destaque recorrencia" *ngIf="!sale.Recorrencia || !sale.Recorrencia.QuantidadeRecorrencia && !sale.Parcelas"></span>
                <span class="texto-destaque valor" *ngIf="isValor()">{{sale.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</span>
              </div>
              <div class="desc-parcelas" *ngIf="sale.Parcelas && sale.Parcelas > 1 && !parcelas">
                <p>em {{ sale.Parcelas }}X de </p>
                <span class="texto-destaque-normal">{{ ((sale.Valor / sale.Parcelas) || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
              </div>
              <div class="data-entrada">
                <span class="texto-data" *ngIf="((sale.Recorrencia && sale.Recorrencia > 0) || (sale.Parcelas && sale.Parcelas > 0)) && !isTodayDate(sale.DataCobranca) && !isPastDate(sale.DataCobranca)">Primeira em </span>
                <span class="valor-data" *ngIf="!isTodayDate(sale.DataCobranca) && !isPastDate(sale.DataCobranca)">{{ getFormatedDate(sale.DataCobranca) }}</span>
              </div>
              <div *ngIf="sale.ValorEntrada" class="valor-entrada flex space-between">
                <span *ngIf="isValor()">Entrada: {{ sale.ValorEntrada.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
              </div>
            </div>
            <hr>
            <div class="venda footer-credito-parcelado" *ngIf="parcelas">
              <p class="desc-venda">Valor total</p>
              <span class="texto-destaque valor" *ngIf="isValor()">{{(this.valorTotalVendas).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</span>
              <div class="desc-parcelas" *ngIf="parcelas > 1">
                <p>em {{ parcelas }}X de</p>
                <span class="texto-destaque-normal">{{ (this.valorParcelado).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
              </div>
              <div class="desc-parcelas" *ngIf="parcelas === 1">
                <p>á vista</p>
              </div>
            </div>
          </div>
        </div>
        <!-- End Info -->

        <!-- ValidationResultError -->
        <div *ngIf="validationResultError" class="panel-body2 panel-body" id="cartoes-cadastrados">
          <span class="valication-result-error">{{validationResultError}}</span>
        </div>
        <!-- End ValidationResultError -->

        <!-- CreditCards List -->
        <div *ngIf="creditCardsList" class="panel-body2 panel-body-altera " id="cartoes-cadastrados">
          <div class="cartoes-cadastrados" id="inner-cartoes-cadastrados">
              <div *ngFor="let c of cards" (click)="selectCreditCard($event, c)" [ngClass]="card.cartaoId === c.CartaoId ? 'cartao' : 'cartao disabled'">
                  <div [ngClass]="'bandeira-cartao ' + getClassBandeiraCartao(c.Bandeira)"></div>
                  <span class="final-pan">xxxx {{c.Numero}}<strong></strong></span>
                  <span class="validade-cartao">Válido até {{c.DataValidade}}<strong></strong></span>
                  <div (click)="toggleMenu($event)" class="editar-cartao-button">
                    <div (click)="showModalRemoveCreditCard($event, c)" class="menu-remove" style="display: none;">Excluir</div>
                  </div>
              </div>
              <div (click)="actionNewCreditCard()" class="cartao novo-cartao">
                <span><span>+</span>&ensp;Novo Cartão</span>
              </div>
          </div>
          <div class="compartilhar">
            <div class="link-field" >
                <span>{{shortLink}}</span>
            </div>
            <div class="button-link-field" (click)="copiarShortUrl()">
              <span>
                {{copyText}}
              </span>
            </div>
          </div>
          <div *ngIf="backUrl && backUrl.length > 0" class="link-back"><a><h4 (click)="actionBackActuar()">Voltar ao Actuar</h4></a></div>
          <button (click)="submit($event)" class="btn btn-primary btn-registrar" id="btn-checkout-selected-card" type="submit">Confirmar</button>
        </div>
        <!-- End CreditCardsList -->

        <!-- New CreditCard -->
        <form (ngSubmit)="submit($event)" *ngIf="newCreditCardForm" id="form-checkout" autocomplete="off" class="panel-body2">
          <div class="row mt-10">
            <div class="col-sm-12">
              <div class="form-group has-feedback text-left" [ngClass]="cartaoInvalido ? 'has-error' : ''">
                <label class="control-label" for="cartao">Nº Cartão de Crédito</label>
                <input (focus)="verifyInputs()" (keyup)="nextInput($event)" type="text" id="cartao" class="form-control" mask="0000 0000 0000 0000" placeholder="XXXX XXXX XXXX XXXX" name="cartao" [(ngModel)]="card.numeroCartao" (bandeira)="setBrand($event)" [contaId]="accountId" appBandeiraCartao>
                <figure class="bandeira-cartao default form-control-feedback"></figure>
                <span class="cartao-invalido" *ngIf="cartaoInvalido" [style.margin-bottom]="mostrarBandeiras ? '15px' : ''">O cartão informado é inválido</span>
                <div class="bandeiras" *ngIf="mostrarBandeiras">
                  <label [ngClass]="bandeiraInvalida ? 'bandeira-invalida' : ''">Selecione a Bandeira</label>
                  <ng-container *ngFor="let brand of brands">
                    <figure [ngClass]="'bandeira-cartao ' + brand.className + (bandeiraAtiva(brand.name) ? ' bandeira-selecionada' : '')" *ngIf="brand.allowSelect" (click)="selecionarBandeiraCartao(brand.name)"></figure>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-3">
              <div class="form-group text-left">
                <label class="control-label" for="validademes">Validade</label>
                <input (focus)="verifyInputs()" (keyup)="nextInput($event)" type="text" maxlength="2" class="form-control" mask="00" placeholder="mês" id="validademes" name="validademes" [(ngModel)]="card.validadeMesCartao">
              </div>
            </div>
            <div class="col-xs-6 col-sm-3">
              <div class="form-group text-left">
                <label class="control-label" for="validadeano">&nbsp;</label>
                <input (focus)="verifyInputs()" (keyup)="nextInput($event)" type="text" maxlength="2" class="form-control" mask="00" placeholder="ano" id="validadeano" name="validadeano" [(ngModel)]="card.validadeAnoCartao">
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 col-sm-offset-2">
              <div class="form-group text-left">
                <label class="control-label" for="codseguranca">Cód. Segurança</label>
                <input (focus)="verifyInputs()" (keyup)="nextInput($event)" type="text" maxlength="4" class="form-control" mask="0000" placeholder="XXX" id="codseguranca" name="codseguranca" [(ngModel)]="card.codigoSegurancaCartao">
              </div>
            </div>
          </div>
          <div class="row mb-60">
            <div class="col-sm-12">
              <div class="form-group text-left">
                <label class="control-label" for="nometitular">Nome do Titular
                  <small> (como escrito no cartão)</small>
                </label>
                <input (focus)="verifyInputs()" (keyup)="nextInput($event)" type="text" class="form-control" placeholder="Nome Sobrenome" id="nometitular" name="nometitular" maxlength="30" [(ngModel)]="card.nomeTitularCartao">
              </div>
            </div>
          </div>
          <div class="compartilhar">
            <div class="link-field" >
              <span>{{shortLink}}</span>
            </div>
            <div class="button-link-field" (click)="copiarShortUrl()">
              <span>
                {{copyText}}
              </span>
            </div>
          </div>
          <div *ngIf="backUrl && backUrl.length > 0 && cards && cards.length === 0" class="link-back"><a><h4 (click)="actionBackActuar()">Voltar ao Actuar</h4></a></div>
          <div *ngIf="cards && cards.length > 0" class="link-back"><a><h4 (click)="actionBack()">Voltar</h4></a></div>

          <button class="btn btn-primary btn-registrar" type="submit" id="btn-checkout">{{ client && !isValidClient() ? 'Continuar' : 'Confirmar' }}</button>
        </form>
        <!-- End New CreditCard -->

        <!-- New CVV Form -->
        <form (ngSubmit)="submit($event)" *ngIf="cvvForm" id="form-checkout" autocomplete="off" class="panel-body2">
          <div class="row mt-10">
            <div class="col-sm-12">
              <div class="form-group has-feedback text-left">
                <label class="control-label" for="cartao">Nº Cartão de Crédito</label>
                <input (focus)="verifyInputs()" (keyup)="nextInput($event)" type="text" id="cartao" class="form-control cartao-credito" placeholder="XXXX XXXX XXXX XXXX" name="cartao" [(ngModel)]="card.numeroCartao" (bandeira)="setBrand($event)" [contaId]="accountId" disabled="disabled" appBandeiraCartao>
                <figure class="bandeira-cartao default form-control-feedback"></figure>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group text-left">
                <label class="control-label" for="validademes">Validade</label>
                <input (focus)="verifyInputs()" (keyup)="nextInput($event)" type="text" maxlength="2" class="form-control" mask="00" placeholder="mês" id="validademes" name="validademes" [(ngModel)]="card.validadeMesCartao" disabled="disabled">
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group text-left">
                <label class="control-label" for="validadeano">&nbsp;</label>
                <input (focus)="verifyInputs()" (keyup)="nextInput($event)" type="text" maxlength="2" class="form-control" mask="00" placeholder="ano" id="validadeano" name="validadeano" [(ngModel)]="card.validadeAnoCartao" disabled="disabled">
              </div>
            </div>
            <div class="col-sm-4 col-sm-offset-2">
              <div class="form-group text-left">
                <label class="control-label" for="codseguranca">Cód. Segurança</label>
                <input (focus)="verifyInputs()" (keyup)="nextInput($event)" type="text" maxlength="4" class="form-control" mask="0000" placeholder="XXX" id="codseguranca" name="codseguranca" [(ngModel)]="card.codigoSegurancaCartao">
              </div>
            </div>
          </div>
          <div class="row mb-60">
            <div class="col-sm-12">
              <div class="form-group text-left">
                <label class="control-label" for="nometitular">Nome do Titular
                  <small> (como escrito no cartão)</small>
                </label>
                <input (focus)="verifyInputs()" (keyup)="nextInput($event)" type="text" class="form-control" placeholder="Nome Sobrenome" id="nometitular" name="nometitular" maxlength="30" [(ngModel)]="card.nomeTitularCartao" disabled="disabled">
              </div>
            </div>
          </div>

          <div *ngIf="cards && cards.length > 0" class="link-back"><a><h4 (click)="actionBack()">Voltar</h4></a></div>

          <button class="btn btn-primary btn-registrar" type="submit" id="btn-checkout">Confirmar</button>
        </form>
        <!-- End CVV Form -->

        <!-- Client Data -->
        <form (ngSubmit)="submit($event)" *ngIf="clientData" id="form-checkout" autocomplete="off" class="panel-body2">
          <div class="row mt-10 mb-70">
            <div class="col-sm-12" *ngIf="_client && !_client.Nome">
              <div class="form-group has-feedback text-left">
                <label class="control-label" for="nome">Nome</label>
                <input type="text" id="nome" class="form-control" [(ngModel)]="client.Nome" name="nome">
              </div>
            </div>
            <div class="col-sm-12" *ngIf="_client && !_client.Email">
              <div class="form-group has-feedback text-left">
                <label class="control-label" id="email" for="client-email">Email</label>
                <input type="email" id="email" class="form-control" [(ngModel)]="client.Email" name="email">
              </div>
            </div>
            <div class="col-sm-12" *ngIf="_client && !_client.CpfCnpj">
              <div class="form-group has-feedback text-left">
                <label class="control-label" for="cpf-cnpj">Cpf</label>
                <input type="text" id="cpf-cnpj" class="form-control" [(ngModel)]="client.CpfCnpj" name="cpfCnpj" mask="000.000.000-00">
              </div>
            </div>
            <div class="col-sm-12" *ngIf="_client && !_client.Telefone">
              <div class="form-group has-feedback text-left" >
                <label class="control-label" for="telefone">Telefone</label>
                <input type="text" id="telefone" class="form-control" [(ngModel)]="client.Telefone" name="telefone" mask="(00) 0 0000-0000">
              </div>
            </div>
            <div class="col-sm-12" *ngIf="_client && !_client.DataNascimento">
              <div class="form-group has-feedback text-left" >
                <label class="control-label" for="data-nascimento">Data de Nascimento</label>
                <input type="text" id="data-nascimento" class="form-control" [(ngModel)]="client.DataNascimento" name="data-nascimento" mask="00/00/0000" [dropSpecialCharacters]="false">
              </div>
            </div>
            <div class="col-sm-12" *ngIf="_client && !_client.Logradouro">
              <div class="form-group has-feedback text-left">
                <label class="control-label" for="logradouro">Logradouro</label>
                <input type="text" id="logradouro" class="form-control" [(ngModel)]="client.Logradouro" name="logradouro">
              </div>
            </div>
            <div class="col-sm-12" *ngIf="_client && !_client.Bairro">
              <div class="form-group has-feedback text-left">
                <label class="control-label" for="bairro">Bairro</label>
                <input type="text" id="bairro" class="form-control" [(ngModel)]="client.Bairro" name="bairro">
              </div>
            </div>
            <div class="col-sm-12" *ngIf="_client && !_client.Cidade">
              <div class="form-group has-feedback text-left">
                <label class="control-label" for="cidade">Cidade</label>
                <input type="text" id="cidade" class="form-control" [(ngModel)]="client.Cidade" name="cidade">
              </div>
            </div>
            <div class="col-sm-12" *ngIf="_client && !_client.Estado">
              <div class="form-group has-feedback text-left">
                <label class="control-label" for="estado">Estado</label>
                <input type="text" id="estado" class="form-control" [(ngModel)]="client.Estado" name="estado">
              </div>
            </div>
            <div class="col-sm-12" *ngIf="_client && !_client.Cep">
              <div class="form-group has-feedback text-left">
                <label class="control-label" for="cep">Cep</label>
                <input type="text" id="cep" class="form-control" [(ngModel)]="client.Cep" name="cep">
              </div>
            </div>
            <div class="col-sm-12" *ngIf="_client && !_client.EnderecoNumero">
              <div class="form-group has-feedback text-left">
                <label class="control-label" for="numero">Número</label>
                <input type="text" id="numero" class="form-control" [(ngModel)]="client.EnderecoNumero" name="numero">
              </div>
            </div>
          </div>

          <div *ngIf="backUrl && backUrl.length > 0 && cards && cards.length === 0" class="link-back"><a><h4 (click)="actionBackActuar()">Voltar ao Actuar</h4></a></div>
          <div *ngIf="cards && cards.length > 0" class="link-back"><a><h4 (click)="actionBack()">Voltar</h4></a></div>

          <button class="btn btn-primary btn-registrar" type="submit" id="btn-checkout">Confirmar</button>
        </form>
        <!-- End Client Data -->

        <!-- Approved Transaction -->
        <div *ngIf="success" id="resultado-sucesso" class="panel-body2">
          <div class="mensagem-sucesso">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
              <title>Aprovada!</title>
              <g id="41c310f0-3cde-4914-9ee4-e4952dc4cf98" data-name="Círculo Aprovado">
                <circle cx="35" cy="35" r="25" style="fill:none;stroke:#00caff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"
                />
              </g>
              <g id="752bc498-d218-4c7d-b07b-03fcc9fc5d57" data-name="Ok Aprovado">
                <polyline points="21.74 29.96 33.7 41.88 68.21 15.36" style="fill:none;stroke:#00caff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"
                />
              </g>
            </svg>
            <h3>{{msgSuccess}}</h3>
          </div>
          <div *ngIf="(tokenId && transactionInfo) || (saleId && transactionInfo)" class="info-transacao-aprovada">
            <div class="dados-aprovados" *ngIf="card && card.numeroCartao">
              <span>
                Cartão
              </span>
              <span class="text-bold info-cartao">
                <span id="numero-cartao">XXXX XXXX XXXX {{card.numeroCartao.length === 4 ? card.numeroCartao : getLastDigits(card.numeroCartao)}}</span>
                <figure [ngClass]="'bandeira-cartao ' + getClassBandeiraCartao(card.bandeiraCartao)"></figure>
              </span>
            </div>
            <hr>
            <div class="dados-aprovados" *ngIf="card && card.validadeMesCartao && card.validadeAnoCartao">
              <span>
                Validade
              </span>
              <span id="validade-cartao" class="text-bold">{{card.validadeMesCartao + '/20' + card.validadeAnoCartao}}</span>
            </div>
            <hr>
            <div class="dados-aprovados" *ngIf="card && card.nomeTitularCartao">
              <span>
                Titular
              </span>
              <span id="titular-cartao" class="text-bold">{{card.nomeTitularCartao}}</span>
            </div>
            <hr>
            <div class="dados-aprovados" *ngIf="transaction && transaction.Transacao && (transaction.Transacao.NumeroComprovante || transaction.Transacao.Tid)">
              <span>
                Comprovante
              </span>
              <span id="numero-comprovante" class="text-bold">{{transaction.Transacao.NumeroComprovante ? transaction.Transacao.NumeroComprovante : transaction.Transacao.Tid}}</span>
            </div>
            <hr>
            <div class="dados-aprovados" *ngIf="transaction && transaction.Transacao && transaction.Transacao.Valor">
              <span>
                <b>Valor</b>
              </span>
              <span id="valor" class="text-bold">{{transaction.Transacao.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</span>
            </div>
          </div>

          <div *ngIf="scheduledTransations && cobrancas.length > 0" class="scheduled-transations">
            <a href="#" (click)="toggleCobrancas($event)">Ver todas transações agendadas</a>
            <div class="row" [ngClass]="showTable ? 'show-table' : 'hide-table'">
              <div class="col-sm-12">
                <table class="checkout-table">
                  <tbody>
                    <tr *ngFor="let cobranca of cobrancas">
                      <td>{{cobranca.DataCobranca}}</td>
                      <td>{{cobranca.Valor}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div *ngIf="backUrl && backUrl.length > 0" class="link-back"><a><h4 (click)="actionBackActuar()">Voltar ao Actuar</h4></a></div>
        </div>
        <!-- End Approved Transaction -->

        <!-- Disapproved Transaction -->
        <div *ngIf="error" class="panel-body2" id="resultado-reprovado">
          <div class="resultado-reprovado">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
              <title>Transação Reprovada</title>
              <g id="f32c9904-9a49-4b84-a96b-1205778d7e8e" data-name="Camada 2">
                <circle cx="35" cy="35" r="25" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"
                />
              </g>
              <g id="5db0cdd3-dede-4fdb-87f7-b5ef7f2d2bf1" data-name="Camada 3">
                <line x1="24.39" y1="24.39" x2="45.61" y2="45.61" class="linha-2" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"
                />
              </g>
              <g id="fb91e5a3-f581-43de-b27f-420a0e4d440d" data-name="Camada 4">
                <line x1="45.61" y1="24.39" x2="24.39" y2="45.61" class="linha-1" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"
                />
              </g>
            </svg>
            <h3 id="erro-principal" class="text-danger"></h3>
          </div>
          <div class="erro-reprovacao">
            <span id="msg-erro" class="text-bold" [innerHTML]="msgError"></span><br>
            <span id="msg-erro" class="text-bold" [innerHTML]="returnedCode"></span>
          </div>
          <div *ngIf="backUrl && backUrl.length > 0" class="link-back"><a><h4 (click)="actionBackActuar()">Voltar ao Actuar</h4></a></div>
          <button (click)="actionReload()" class="btn btn-primary btn-confirmar" id="reinicia-venda" type="button">Tentar novamente</button>
        </div>
        <!-- End Disapproved Transaction -->
      </div>
    </div>

    <!-- Modal -->
    <div class="modal-checkout" [ngClass]="showModal ? 'modal-checkout-show' : ''">
      <div class="container">
        <div class="icon" *ngIf="accountNotAllowed">
          <img src="/assets/icones/error.svg" />
        </div>
        <div class="text">
            <span *ngIf="accountNotAllowed">Ops!</span>
            <span>{{msgBlock}}</span>
        </div>
        <div class="button-not-allowed" *ngIf="accountNotAllowed">
          <a href="https://actuar.com/pagamento-recorrente/"><button class="btn btn-registrar">Habilite Agora!</button></a>
        </div>
      </div>
    </div>
    <!-- Fim Modal -->

    <!-- Footer -->
    <div class="cls-content-lg text-sm-center">
      <div class="rodape">
        <div class="logo-paguela-cinza">
          <svg id="210736b6-5007-4dc1-913c-27872a8bca0e" data-name="Logo Pague.lá Cinza" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 84">
            <title>Pague.lá</title>
            <path d="M279,61.14c3.41,0,4.48.87,4.48,3a12.4,12.4,0,0,1-1,5.15c-.87,1.47-2,1.87-5.08,1.87s-4.48-.6-4.48-3.07a15.07,15.07,0,0,1,.74-4.21C274.46,61.75,275.73,61.14,279,61.14Zm19.07-.47a20.56,20.56,0,0,0-.27,2.54c0,1.74.74,2.27,2.81,2.27h1.07c1.14,0,1.47.67,1.47,1.67,0,2.74-1.2,4.48-6.42,4.48s-7.55-1.94-7.55-6.15a18.91,18.91,0,0,1,.27-3.21l6-37.7c.27-1.87,2.47-2.61,4.41-2.61,1.74,0,4,.27,4,2a3.64,3.64,0,0,1-.07.74Zm27-10.56c2.07-.2,2.67-.47,3.14-3.21a9.46,9.46,0,0,0,.13-1.87c0-2.21-.94-3.88-5.62-3.88a38.54,38.54,0,0,0-8,.8c-1.34.33-2.14-.6-2.14-2.07a3.48,3.48,0,0,1,1.54-3.34c1.94-1.27,5.82-1.87,10.29-1.87,8.56,0,12.3,2.27,12.3,8.29,0,1-.13,2.14-.27,3.41l-3.34,20.72c-.54,3.48-5.61,4.48-13.9,4.48-9.36,0-12.5-2.34-12.5-8.09,0-3.88.94-7.69,3.34-9.76,1.94-1.74,5.08-2.54,9.49-3Zm1.6,7.89a3.5,3.5,0,0,0,.07-.8c0-1.54-.94-2.14-3.34-2.14h-3c-2.21,0-3.61.4-4.41,1.8a12.41,12.41,0,0,0-1.34,6.35c0,2.27,1.27,2.81,5.21,2.81,5,0,5.62-.33,6.22-4.48Zm-.37-30.19a2.82,2.82,0,0,1,.8-1.67L332,19.48c1-1.27,1.87-1.94,3.21-1.94,2.21,0,3.34,1.34,3.34,2.74a3.45,3.45,0,0,1-1.27,2.34L331.52,28c-1.54,1.47-2.21,1.6-3.14,1.6A1.84,1.84,0,0,1,326.3,27.81ZM158.43,50.12c2.07-.2,2.67-.47,3.14-3.21A9.46,9.46,0,0,0,161.7,45c0-2.21-.94-3.88-5.62-3.88a38.54,38.54,0,0,0-8,.8c-1.34.33-2.14-.6-2.14-2.07a3.48,3.48,0,0,1,1.54-3.34c1.94-1.27,5.82-1.87,10.29-1.87,8.56,0,12.3,2.27,12.3,8.29,0,1-.13,2.14-.27,3.41l-3.34,20.72c-.54,3.48-5.61,4.48-13.9,4.48-9.36,0-12.5-2.34-12.5-8.09,0-3.88.94-7.69,3.34-9.76,1.94-1.74,5.08-2.54,9.49-3ZM160,58a3.5,3.5,0,0,0,.07-.8c0-1.54-.94-2.14-3.34-2.14h-3c-2.21,0-3.61.4-4.41,1.8A12.41,12.41,0,0,0,148,63.22c0,2.27,1.27,2.81,5.21,2.81,5,0,5.62-.33,6.22-4.48Zm31,11.43c0-.8-.4-.93-1.81-.93-.93,0-2.27.27-4.88.27-7.82,0-11.3-2.41-11.3-9.63,0-5.95,1.81-15.91,6.48-20.52,2.94-2.94,7.15-3.94,13.44-3.94,8.42,0,11.43.6,11.43,3.28a5.72,5.72,0,0,1-.07,1L199.55,68.7,199,72c-2.14,10.29-9.63,11-17.85,11-5,0-10.23-.33-10.23-3.54,0-1.81.67-3.68,2.54-3.48a67.52,67.52,0,0,0,7.75.54c5.95,0,8.42-1,9.29-4.21A12.06,12.06,0,0,0,191,69.43Zm4-24.6c.07-.6.2-1.34.2-1.81,0-1.94-1.2-2.41-4.21-2.41a7.77,7.77,0,0,0-4.34.94c-3.34,2.47-5.08,11.56-5.08,16.71,0,3.61,1.34,4.88,5.08,4.88,4.48,0,5.55-1.34,6.22-5.41Zm39.18,21.86c-.4,2.61-.8,3.54-3,4a46.29,46.29,0,0,1-10.69,1.07c-10.43,0-13-3.41-13-8.76a25.94,25.94,0,0,1,.33-3.74l3.34-21.59c.33-2.07,2-2.61,4.48-2.61,2.07,0,3.94.34,3.94,2a4.75,4.75,0,0,1-.07.87L216.34,58a26.08,26.08,0,0,0-.33,3.48c0,3.28,1.54,3.88,5.21,3.88,4.08,0,4.88-.27,5.21-2.54l3.94-25.13c.34-2.07,1.94-2.61,4.41-2.61,2.14,0,4,.34,4,2a4.85,4.85,0,0,1-.07.87Zm18.4-10.49c-2.54.2-2.54,1.34-2.54,3.34,0,3.21.67,5.75,7,5.75a30.94,30.94,0,0,0,7.82-1.07,2.48,2.48,0,0,1,.67-.07c.87,0,1.67.6,1.67,2.07,0,4.75-4.28,5.55-11.5,5.55-9,0-13.9-3.21-13.9-11.9A57.05,57.05,0,0,1,243,49.78c2.27-11.43,7.69-15.1,16.44-15.1,8.42,0,12,3.28,12,10,0,7.89-3.08,10.56-11.43,11.1Zm-.13-11.43a15,15,0,0,0-1.14,5.15c0,.74.47,1.14,1.4,1.14h4.88c4.28,0,6.15-1.47,6.15-6.35,0-2.74-1-4.14-5.08-4.14C255.93,40.62,254,41.56,252.45,44.77Zm-137,24.13c-.34,2-2.21,2.67-4.81,2.67-1.81,0-3.88-.33-3.88-1.94a8.26,8.26,0,0,1,.13-1l7.27-41.41c.47-3.21,2.47-5.08,6.62-5.08h7.42c8.62,0,13.3,2.67,13.3,11.63,0,12.7-7.15,17.58-18.18,17.58H122c-2.47,0-3.21.74-3.41,2.14Zm4.93-26.84a14.62,14.62,0,0,0-.13,1.47c0,1.4.74,1.6,2.87,1.6,7.08,0,9.89-4.08,9.89-11.23,0-4.21-2.27-5.55-6.15-5.55s-4.14,0-4.68,3.07ZM48.93,1C23.35,1,13.44,5.71,7.18,22.47c-3.67,9.95-5.75,25.66-5.75,33,0,12.26,4.82,18.65,14.18,21.68L27.76,23.33c.9-4.59,3.9-7.28,9.84-7.28H48.22c12.34,0,18.86,3.83,18.21,16.66-.92,18.18-11.51,25.17-27.3,25.17H37.31c-3.54,0-4.65,1.06-5,3.06L27.56,79.25c2.74.2,5.69.29,8.84.29,24,0,32.88-3.14,39.67-14.66,5.22-9.95,7.83-26.71,7.83-40.32C83.9,7.81,75.55,1,48.93,1Zm5.33,31.9c.3-6-2.85-7.94-8.4-7.94s-5.93,0-6.92,4.39L35.59,44.58a21.15,21.15,0,0,0-.29,2.1c-.1,2,.94,2.3,4,2.3C49.43,49,53.75,43.15,54.27,32.9Z"
              style="fill:#bfbfbf" />
          </svg>
        </div>
      </div>
    </div>
    <!-- Footer -->
  </div>
</div>

<app-modal-detail [showModal]="modalRemoveCreditCard" (eventClose)="closeModalRemoveCreditCard()">
  <ng-container *ngIf="!cartaoRemovido">
    <div class="modal-header header-remover">
      <h2>Excluir Cartão?</h2>
    </div>
    <div class="modal-body">
      <h3>Isso irá cancelar todas as recorrências com este cartão.</h3>
      <div class="row">
        <div class="col-12">
          <span>Digite <span class="text-danger">"EXCLUIR"</span> para continuar</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <input class="input textarea" id="textarea-excluir" name="texto-excluir" [(ngModel)]="textRemoveCreditCard">
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span class="color-red">{{ errorRemoveCreditCard }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-default" (click)="closeModalRemoveCreditCard()">Voltar</button>
          <button class="btn btn-remover" id="btn-remover" (click)="removeCard($event)">Excluir</button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="cartaoRemovido">
    <div class="modal-header header-removido">
      <h2>Cartão Excluído!</h2>
    </div>
    <div class="modal-body">
      <h3 class="text-center">Cartão excluído com sucesso!</h3>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-default btn-excluido" (click)="closeModalRemoveCreditCard()">OK</button>
        </div>
      </div>
    </div>
  </ng-container>
</app-modal-detail>

<app-backdrop-bloqueio [mostrarBloqueio]="bloqueio"></app-backdrop-bloqueio>
